export default __webpack_public_path__ + "static/media/bgImage.59274878.png";